var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 51,
    viewBox: "0 0 39 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 50.25H0.5V45.5C0.5 42.3506 1.75111 39.3301 3.97811 37.1031C6.2051 34.8761 9.22555 33.625 12.375 33.625H26.625C29.7744 33.625 32.7949 34.8761 35.0219 37.1031C37.2489 39.3301 38.5 42.3506 38.5 45.5V50.25ZM19.5 28.875C17.6287 28.875 15.7757 28.5064 14.0468 27.7903C12.3179 27.0742 10.747 26.0245 9.42373 24.7013C8.10049 23.378 7.05085 21.8071 6.33472 20.0782C5.61859 18.3493 5.25 16.4963 5.25 14.625C5.25 12.7537 5.61859 10.9007 6.33472 9.17176C7.05085 7.44287 8.10049 5.87196 9.42373 4.54873C10.747 3.22549 12.3179 2.17585 14.0468 1.45972C15.7757 0.743587 17.6287 0.375 19.5 0.375C23.2793 0.375 26.9039 1.87633 29.5763 4.54873C32.2487 7.22112 33.75 10.8457 33.75 14.625C33.75 18.4043 32.2487 22.0289 29.5763 24.7013C26.9039 27.3737 23.2793 28.875 19.5 28.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.e8a6131613455f9a88595f4bb4f73996.svg";
export { ForwardRef as ReactComponent };